import React, { createContext, PropsWithChildren, useContext, useMemo, useState } from 'react';

interface BulletinContextType {
  sessionStartedAt: Date;
  isManagementDialogOpen: boolean;
  setManagementDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const BulletinContext = createContext<BulletinContextType | undefined>(undefined);

export const BulletinProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [sessionStartedAt] = useState(() => new Date());
  const [isManagementDialogOpen, setManagementDialogOpen] = useState(false);
  const value = useMemo(() => ({
    sessionStartedAt,
    isManagementDialogOpen,
    setManagementDialogOpen,
  }), [sessionStartedAt, isManagementDialogOpen]);

  return <BulletinContext.Provider value={value}>{children}</BulletinContext.Provider>;
};

export const useBulletinContext = () => {
  const context = useContext(BulletinContext);
  if (!context) throw new Error('useBulletinContext must be used within a BulletinProvider');
  return context;
};
